import FoundButton from '../components/FoundButton';

const renderFoundButton = (_: unknown, row: any) => {
  return <FoundButton inboxId={row.id} currentTags={row.tags} />;
};

export default renderFoundButton;
